export default __webpack_public_path__ + "static/media/notifications-BG.2945f0cc.png";